/* import __COLOCATED_TEMPLATE__ from './pull-brands.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type { PulseAccordion } from 'glint/pulse';

export interface Args {
  onContinue: () => void;
  accordion: PulseAccordion;
}

const PullBrands = templateOnlyComponent<Args>();
export default PullBrands;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::PullBrands': typeof PullBrands;
    'standalone/zendesk/deploy/common/pull-brands': typeof PullBrands;
  }
}
